import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * OfflineBanner — global ağ bağlantısı durum göstergesi.
 * Bağlantı kesildiğinde kırmızı banner, yeniden kurulduğunda 3 sn yeşil banner.
 * z-[60]: modal'lardan (z-50) üstte konumlanır.
 */
export default function OfflineBanner() {
  const { t } = useLanguage();
  const [isOffline, setIsOffline] = useState(
    () => typeof navigator !== 'undefined' && navigator.onLine === false
  );
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    let reconnectTimer = null;

    const onOffline = () => {
      setIsOffline(true);
      setShowReconnected(false);
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
        reconnectTimer = null;
      }
    };

    const onOnline = () => {
      setIsOffline(false);
      setShowReconnected(true);
      if (reconnectTimer) clearTimeout(reconnectTimer);
      reconnectTimer = setTimeout(() => setShowReconnected(false), 3000);
    };

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);

    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
      if (reconnectTimer) clearTimeout(reconnectTimer);
    };
  }, []);

  if (!isOffline && !showReconnected) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed top-0 left-0 right-0 z-[60] px-4 py-2 text-center text-sm font-semibold shadow-md ${
        isOffline ? 'bg-red-600 text-white' : 'bg-emerald-600 text-white'
      }`}
    >
      {isOffline ? (
        <>
          <span aria-hidden="true">⚠️</span>{' '}
          {t('offlineBannerOffline') ||
            'Bağlantı kesildi — değişiklikler kaybolabilir, lütfen ağı kontrol edin.'}
        </>
      ) : (
        <>
          <span aria-hidden="true">✓</span>{' '}
          {t('offlineBannerReconnected') || 'Bağlantı yeniden kuruldu.'}
        </>
      )}
    </div>
  );
}
